// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xFDbRTLNFy7I7XbmXPYH{font-weight:bold;font-size:14px;color:var(--color-main)}`, "",{"version":3,"sources":["webpack://./src/components/layout/MainHeader/components/NicknameBox/styles.module.sass"],"names":[],"mappings":"AAAA,sBACE,gBAAA,CACA,cAAA,CACA,uBAAA","sourcesContent":[".nickname\n  font-weight: bold\n  font-size: 14px\n  color: var(--color-main)"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nickname": `xFDbRTLNFy7I7XbmXPYH`
};
export default ___CSS_LOADER_EXPORT___;
